<template>
  <div class="box agency">
    <div class="left-box">
      <div class="head-box">
        <h4>代理商管理</h4>
        <div>
          <i
            class="el-icon-circle-plus-outline c-pointer"
            @click="
              editMenu = {};
              menuDialog = true;
            "
          ></i>
          <i class="el-icon-edit c-pointer c-m-l-10" @click="menuEdit()"></i>
          <i class="el-icon-delete c-pointer c-m-l-10" @click="menuDelete()"></i>
        </div>
      </div>
      <div class="left-content row">
        <div class="content-group">
          <div
            v-for="(item, i) in roles"
            :key="i"
            :class="activeRole._id == item._id ? 'is-selected' : ''"
            class="content-item c-flex c-flex-item c-flex-between"
            @click="roleClick(item)"
          >
            <span>{{ item.name }}</span>
            <i
              class="el-icon-document-copy c_pointer"
              title="点击复制代理商模板市场渠道链接"
              @click.stop="
                osg.doCopy(
                  `${origin}/Templates?aid=${item._id}`,
                  `已复制${item.name}的模板市场渠道链接`
                )
              "
            ></i>
          </div>
        </div>
      </div>
    </div>
    <div class="right-box c-p-10">
      <el-button type="primary" class="tab-button" @click.native="doNew">添加租户</el-button>
      <el-tabs v-model="activeTab">
        <el-tab-pane label="租户列表" name="menu">
          <el-table
            ref="table"
            :data="fpi.data"
            empty-text="暂无租户"
            style="width: 100%"
            highlight-current-row
          >
            <el-table-column prop="name" label="名称" width="150px" fixed></el-table-column>
            <el-table-column prop="code" label="编号" width="100px"></el-table-column>
            <el-table-column prop="phone" label="手机" width="120px"></el-table-column>
            <!-- <el-table-column
              prop="vipState"
              label="状态"
              width="120px"
              :formatter="formatterState"
            ></el-table-column>
            <el-table-column
              prop="vipType"
              label="类型"
              width="120px"
              :formatter="formatterType"
            ></el-table-column>
            <el-table-column prop="vipEndDate" label="会员截止日期" width="120px"></el-table-column>
            <el-table-column
              prop="vipMaxUserCout"
              label="会员最大用户数"
              width="120px"
            ></el-table-column>
            <el-table-column
              prop="vipMaxWorkflowCount"
              label="会员最大流程数"
              width="120px"
            ></el-table-column>
            <el-table-column
              prop="vipSuit"
              label="当前套餐"
              width="120px"
              :formatter="formatterSuit"
            ></el-table-column>
            <el-table-column prop="level" label="等级"></el-table-column> -->
            <el-table-column
              prop="email"
              label="邮箱"
              width="150px"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="address"
              label="地址"
              width="150px"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="exts.userCount" label="用户数量"></el-table-column>
            <el-table-column prop="state" label="状态" width="100">
              <template slot-scope="scope">
                <el-tag type="success" v-if="scope.row.state == 1">已启用</el-tag>
                <el-tag type="danger" v-else-if="scope.row.state == 0">已禁用</el-tag>
                <el-tag type="success" v-else>scope.row.state</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" min-width="140px"></el-table-column>
            <el-table-column fixed="right" width="100px" v-if="osg.has('Agency,column')">
              <template slot-scope="scope">
                <el-dropdown>
                  <el-button>
                    操作
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      @click.native="doEdit(scope.row)"
                      v-if="osg.has('Agency,edit')"
                    >
                      编辑
                    </el-dropdown-item>
                    <el-dropdown-item
                      @click.native="doEnable(scope.row._id)"
                      v-if="scope.row.state == 0 && osg.has('Agency,enable')"
                    >
                      启用
                    </el-dropdown-item>
                    <el-dropdown-item
                      @click.native="doDisable(scope.row._id)"
                      v-if="scope.row.state == 1 && osg.has('Agency,disable')"
                    >
                      禁用
                    </el-dropdown-item>
                    <el-dropdown-item
                      @click.native="doReset(scope.row._id)"
                      v-if="osg.has('Agency,resetPassword')"
                    >
                      密码重置
                    </el-dropdown-item>
                    <el-dropdown-item
                      @click.native="getLog(scope.row)"
                      v-if="osg.has('Agency,log')"
                    >
                      操作日志
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="osg.has('Agency,buy')"
                      @click.native="
                        billingFormData = {};
                        billingOpenDetail = true;
                        billingFormData.tenantId = scope.row._id;
                      "
                      size="mini"
                    >
                      购买新套餐
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="osg.has('Agency,update')"
                      @click.native="doUpgrade(scope.row)"
                      size="mini"
                    >
                      升级套餐
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
          <!--代理商编辑-->
          <el-dialog title="代理商" :visible.sync="menuDialog" width="500px">
            <el-form :model="editMenu" :rules="rules" ref="editMenu">
              <el-form-item label="编码" label-width="110px" prop="code">
                <el-input v-model="editMenu.code"></el-input>
              </el-form-item>
              <el-form-item label="名称" label-width="110px" prop="name">
                <el-input v-model="editMenu.name"></el-input>
              </el-form-item>
              <el-form-item label="手机号" label-width="110px" prop="phone">
                <el-input v-model="editMenu.phone"></el-input>
              </el-form-item>
              <el-form-item
                label="邮箱"
                label-width="110px"
                prop="email"
                :rules="{
                  required: true,
                  message: '请输入邮箱'
                }"
              >
                <el-input v-model="editMenu.email" placeholder="将作为登录账号"></el-input>
              </el-form-item>
              <el-form-item label="地址" label-width="110px">
                <el-input v-model="editMenu.address"></el-input>
              </el-form-item>
              <!-- <el-form-item label="等级" label-width="110px">
                <el-input v-model="editMenu.level"></el-input>
              </el-form-item> -->
            </el-form>
            <div slot="footer">
              <el-button type="primary" @click="menuSave(editMenu)">确 定</el-button>
              <el-button @click="menuDialog = false">取 消</el-button>
            </div>
          </el-dialog>
          <el-dialog title="租户信息" :visible.sync="openDetail" width="500px">
            <el-form
              :model="formData"
              ref="formData"
              :rules="rules"
              label-width="110px"
              label-position="left"
              hide-required-asterisk
            >
              <el-form-item label="编号" prop="code">
                <el-input v-model="formData.code"></el-input>
              </el-form-item>
              <el-form-item label="名称" prop="name">
                <el-input v-model="formData.name"></el-input>
              </el-form-item>
              <el-form-item label="手机" prop="phone">
                <el-input v-model="formData.phone"></el-input>
              </el-form-item>
              <el-form-item
                label="邮箱"
                prop="email"
                :rules="{
                  required: true,
                  message: '请输入邮箱'
                }"
              >
                <el-input v-model="formData.email" placeholder="将作为登录账号"></el-input>
              </el-form-item>
              <el-form-item label="地址">
                <el-input v-model="formData.address"></el-input>
              </el-form-item>
              <!-- <el-form-item label="等级">
                <el-input v-model="formData.level"></el-input>
              </el-form-item> -->
            </el-form>
            <div slot="footer">
              <el-button type="primary" @click="doSave">确 定</el-button>
              <el-button @click="doInit">取 消</el-button>
            </div>
          </el-dialog>
          <el-dialog title="套餐详情" :visible.sync="billingOpenDetail">
            <el-form
              :model="billingFormData"
              :rules="rules"
              ref="billingFormData"
              label-width="120px"
              label-position="left"
              hide-required-asterisk
            >
              <el-form-item label="选择套餐">
                <el-select v-model="billingFormData.vipSuit">
                  <el-option
                    v-for="item in options.vipSuit"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    v-show="item.value != '0'"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="支付状态">
                <el-input v-model="billingFormData.payState"></el-input>
              </el-form-item>
              <el-form-item label="原价钱">
                <el-input v-model="billingFormData.price"></el-input>
              </el-form-item>
              <el-form-item label="价钱">
                <el-input v-model="billingFormData.origionPrice"></el-input>
              </el-form-item>
              <el-form-item label="选择开始日期">
                <el-date-picker
                  v-model="billingFormData.vipStartDate"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="选择截至日期">
                <el-date-picker
                  v-model="billingFormData.vipEndDate"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="会员截止日期"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="会员最大用户数">
                <el-input v-model="billingFormData.vipMaxUserCout"></el-input>
              </el-form-item>
              <el-form-item label="会员最大流程数">
                <el-input v-model="billingFormData.vipMaxWorkflowCount"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer">
              <el-button type="primary" @click="doSaveBilling">确 定</el-button>
              <el-button @click="doInit">取 消</el-button>
            </div>
          </el-dialog>
          <el-dialog
            :title="(log.row.name || '') + '-操作日志'"
            :visible.sync="log.show"
            width="800px"
          >
            <div class="c-flex" style="margin:0 0 10px">
              <el-date-picker
                v-model="log.searchDate"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                clearable
                @change="
                  log.fpi.page = 1;
                  getLog();
                "
                style="width:50%"
              ></el-date-picker>
              <el-input
                placeholder="请输入要查询的内容"
                v-model="log.searchValue"
                clearable
                style="width:50%"
                @clear="
                  log.fpi.page = 1;
                  getLog();
                "
                @keyup.enter.native="
                  log.fpi.page = 1;
                  getLog();
                "
                class="c-m-l-10"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="
                    log.fpi.page = 1;
                    getLog();
                  "
                ></el-button>
              </el-input>
            </div>
            <div class="content-table c-flex c-flex-col">
              <el-table
                ref="logtable"
                :data="log.fpi.data"
                empty-text="暂无数据"
                height="calc(100% - 50px)"
              >
                <el-table-column
                  prop="createUserName"
                  label="名称"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="uaccount"
                  label="账号"
                  min-width="150px"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column prop="memo" label="操作" show-overflow-tooltip></el-table-column>
                <el-table-column
                  prop="createTime"
                  label="操作时间"
                  min-width="140px"
                ></el-table-column>
              </el-table>
              <el-pagination
                class="pagination"
                @size-change="pageSizeChange"
                @current-change="pageChange"
                :current-page="log.fpi.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="log.fpi.rows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="log.fpi.total"
              ></el-pagination>
            </div>
          </el-dialog>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
export default {
  name: 'register',
  data() {
    return {
      activeTab: 'menu', //当前激活tab
      menuDialog: false,
      buttonDialog: false,
      type: null, // 菜单类型，入口传参
      activeRole: {}, //当前选中
      editMenuIndex: '', //编辑菜单下标
      editButtonIndex: '', //编辑按钮下标
      editMenu: {}, //当前编辑的menu
      rules: this.$util.rules,
      isEdit: false,
      editButton: {}, //当前编辑的button
      roles: [], //代理商一级菜单
      options: {
        codecfg_vipState: { codeId: 'VIPSTATE' },
        codecfg_vipType: { codeId: 'VIPTYPE' },
        codecfg_vipSuit: { codeId: 'VIPSUIT' }
      },
      fpi: {},
      openDetail: false,
      billingFormData: {}, //租户计费表单
      billingOpenDetail: false,
      formData: {
        vipState: 0,
        vipType: 0,
        vipSuit: 0
      },
      origin: window.location.origin,
      log: {
        row: {},
        searchDate: [],
        searchValue: '',
        fpi: { page: 1, rows: 20, data: [] },
        show: false
      }
    };
  },
  mounted() {
    window.$this = this;
    this.getMenu().then(() => {
      this.activeRole = this.roles[0] || {};
      this.osg.getFields('account', () => {
        this.getData();
      });
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      if (this.log.show) {
        this.log.fpi.rows = pageSize;
        this.getLog();
      }
    },
    pageChange(currentPage) {
      if (this.log.show) {
        this.log.fpi.page = currentPage;
        this.getLog();
      }
    },
    //获取租户分页列表
    getData() {
      if (!this.activeRole._id) return;
      var params = {
        page: this.fpi.page || 0,
        rows: this.fpi.rows || 20,
        sortField: 'createTime',
        sortOrder: 'desc',
        'is:agencyId|string#and': this.activeRole._id
      };
      this.osg.ajax('tenant/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    //重置表单
    resetFields(formName) {
      this.$refs[formName].resetFields();
    },
    //添加菜单
    menuAdd() {
      this.menuDialog = true;
    },
    //获取菜单
    getMenu() {
      return new Promise(reslove => {
        this.osg.ajax('agency/query.do', null, res => {
          this.roles = res.data;
          reslove(res);
        });
      });
    },
    //选择菜单
    roleClick(item) {
      this.activeRole = this.$util.deepCopy(item);
      this.getData();
    },
    //编辑菜单按钮
    menuEdit(obj, index) {
      console.log(this.activeRole);
      this.editMenuIndex = index;
      if (obj) {
        this.editMenu = obj; //this.$util.deepCopy(obj);
      } else {
        if (!this.activeRole._id) {
          this.osg.toast('请选择要编辑菜单！', 'warning');
          return;
        }
        this.editMenu = this.$util.deepCopy(this.activeRole);
      }
      this.menuDialog = true;
    },
    //保存菜单
    menuSave(obj) {
      //校验
      if (!this.osg.validate('editMenu')) {
        return;
      }
      delete obj.functionList;
      delete obj.buttonList;
      this.osg.ajax('agency/upsert.do', obj, () => {
        this.osg.toast('保存成功！');
        //添加顶级菜单
        this.getMenu();
        this.menuDialog = false;
      });
    },

    //删除菜单按钮
    menuDelete() {
      if (!this.activeRole._id) {
        this.osg.toast('请选择要编辑菜单！', 'warning');
        return;
      }
      this.osg.confirm(`是否确认删除"${this.activeRole.name}"？`, () => {
        this.osg.ajax(`agency/remove/${this.activeRole._id}.do`, {}, () => {
          this.getMenu();
          this.osg.toast('删除成功');
        });
      });
    },
    //新增租户
    doNew() {
      if (!this.activeRole._id) {
        this.osg.toast('请选择要编辑菜单！', 'warning');
        return;
      }
      this.doInit();
      this.isEdit = false;
      this.openDetail = true;
    },
    //编辑租户
    doEdit(row) {
      this.formData = row;
      this.isEdit = true;
      this.openDetail = true;
    },
    //租户启用
    doEnable(id) {
      this.osg.ajax('tenant/enable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    //租户禁用
    doDisable(id) {
      this.osg.ajax('tenant/disable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    //租户重置密码
    doReset(id) {
      this.osg.ajax('tenant/upsertAccount/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    //升级套餐
    doUpgrade(row) {
      this.billingFormData = JSON.parse(JSON.stringify(row));
      this.billingFormData.vipSuit = String(this.billingFormData.vipSuit);
      this.billingFormData.parentTransactionId = row._id;
      this.billingFormData.tenantId = row._id;
      delete this.billingFormData.name;
      delete this.billingFormData.code;
      delete this.billingFormData.phone;
      delete this.billingFormData.email;
      delete this.billingFormData.address;
      this.billingOpenDetail = true;
    },
    //保存套餐
    doSaveBilling() {
      delete this.billingFormData.createTime;
      delete this.billingFormData.updateTime;
      let that = this;
      this.osg.ajax('basic/tenantTransaction/upsert.do', that.billingFormData, () => {
        this.osg.toast('保存成功！');
        this.getData();
        this.doInit();
      });
    },
    //保存租户
    doSave() {
      let that = this;
      this.formData.agencyId = this.activeRole._id;
      if (this.osg.validate()) {
        if (!this.isEdit) {
          this.formData.vipState = 1;
          this.formData.vipType = 0;
          this.formData.vipEndDate = '2020-04-28 00:00:00';
          this.formData.vipMaxUserCout = 5;
          this.formData.vipMaxWorkflowCount = 5;
          this.formData.vipSuit = 0;
        }
        this.osg.ajax('tenant/upsert.do', this.formData, () => {
          that.doInit();
          that.getData();
          that.osg.toast('保存成功！');
        });
      }
    },
    //重置租户
    doInit() {
      this.openDetail = false;
      this.billingOpenDetail = false;
      this.formData = {};
      this.billingFormData = {};
      if (this.$refs.formData) this.$refs.formData.resetFields();
      if (this.$refs.billingFormData) this.$refs.billingFormData.resetFields();
    },
    formatterSuit(row, column, cellValue) {
      return this.osg.codelabel('vipSuit', cellValue);
    },
    formatterState(row, column, cellValue) {
      return this.osg.codelabel('vipState', cellValue);
    },
    formatterType(row, column, cellValue) {
      return this.osg.codelabel('vipType', cellValue);
    },
    // 查看操作日志
    getLog(row) {
      if (row) {
        this.log = {
          row: row,
          searchDate: [],
          searchValue: '',
          fpi: { page: 1, rows: 20, data: [] },
          show: false
        };
      } else {
        this.log.row = this.log.row || {};
        this.log.searchDate = this.log.searchDate || [];
      }
      this.osg.ajax(
        'oplog/query.do',
        {
          'is:state|integer#and': 1,
          page: this.log.fpi.page,
          rows: this.log.fpi.rows,
          'regex:createUserName|string#or': this.log.searchValue,
          'regex:uaccount|string#or': this.log.searchValue,
          'regex:memo|string#or': this.log.searchValue,
          'gte:createTime|datetime#and': this.log.searchDate[0],
          'lte:createTime|datetime#and': this.log.searchDate[1],
          tenantId: this.log.row._id
        },
        res => {
          this.log.fpi = res;
          this.log.show = true;
          this.$nextTick(() => {
            this.$refs.logtable.doLayout();
            this.$forceUpdate();
          });
        }
      );
    }
  },
  watch: {
    $route() {
      window.$this = this;
      this.getMenu();
    }
  }
};
</script>
<style>
.content-item:hover {
  content: '';
}
.agency .el-dialog__body {
  padding: 20px !important;
  display: flex;
  flex-direction: column;
}
</style>
